import React from "react";
import Loader from "../Common/Loader";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import moment from "moment";
const FixturePointModal = (props) => {
  const { show, player_points, player_name, team_name, fixture_date } = props;
  return (
    <>
      <Modal {...props} show={show} size="lg">
        <Modal.Body style={{ maxHeight: "670px", overflowX: "auto" }}>
          <div className="pointsystem-table">
            <div className="datefilter">
              <ul>
                <li>
                  <div className="playeroverview">
                    <label>Name</label>
                    <h5>{player_name}</h5>
                  </div>
                </li>
                <li>
                  <div className="playeroverview">
                    <label>Team</label>
                    <h5>{team_name}</h5>
                  </div>
                </li>
                <li>
                  <div className="playeroverview">
                    <label>Date</label>
                    <h5>{moment(fixture_date).format("D.MM.YYYY")}</h5>
                  </div>
                </li>
              </ul>
            </div>
            <div className="player_profile_modal">
              <table className="table">
                <tbody>
                  <tr>
                    <td>
                      <strong>Runs</strong>
                    </td>
                    <td>
                      {player_points?.rs ? (
                        <span>{player_points?.rs}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>4s</strong>
                    </td>
                    <td>
                      {player_points?.fours ? (
                        <span>{player_points?.fours}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>6s</strong>
                    </td>
                    <td>
                      {player_points?.sixes ? (
                        <span>{player_points?.sixes}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Overs</strong>
                    </td>
                    <td>
                      {player_points?.overs ? (
                        <span>{player_points?.overs}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Maidens</strong>
                    </td>
                    <td>
                      {player_points?.mdns ? (
                        <span>{player_points?.mdns}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Runs Given</strong>
                    </td>
                    <td>
                      {player_points?.run ? (
                        <span>{player_points?.run}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Wickets</strong>
                    </td>
                    <td>
                      {player_points?.wks ? (
                        <span>{player_points?.wks}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Catches</strong>
                    </td>
                    <td>
                      {player_points?.cs ? (
                        <span>{player_points?.cs}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Catches WK</strong>
                    </td>

                    <td>
                      {player_points?.cwks ? (
                        <span>{player_points?.cwks}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Stumpings</strong>
                    </td>
                    <td>
                      {player_points?.sts ? (
                        <span>{player_points?.sts}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>RO Direct</strong>
                    </td>
                    <td>
                      {player_points?.rods ? (
                        <span>{player_points?.rods}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>RO Assist</strong>
                    </td>
                    <td>
                      {player_points?.roas ? (
                        <span>{player_points?.roas}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Duck</strong>
                    </td>
                    <td>
                      {player_points?.dks ? (
                        <span>{player_points?.dks}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Hat-Trick</strong>
                    </td>
                    <td>
                      {player_points?.hattrick ? (
                        <span>{player_points?.hattrick}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Fantasy Points</strong>
                    </td>
                    <td>
                      {player_points?.fantasy_points ? (
                        <span>{player_points?.fantasy_points}</span>
                      ) : (
                        <span>0</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Value Change</strong>
                    </td>
                    <td>
                      {" "}
                      {player_points?.price_change >= 0 ? (
                        <strong>+${player_points?.price_change}m</strong>
                      ) : (
                        <strong>-${player_points?.price_change}m</strong>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Button className="border-btn" onClick={props.onHide}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FixturePointModal;
